import Vue from 'vue';
import {
  NavBar,
  Tag,
  Grid,
  GridItem,
  Collapse,
  CollapseItem,
  Image,
  Col,
  Row,
  Search,
  Icon,
  Picker,
  Popup,
  Cell,
  Form,
  Field,
  Button,
  DropdownMenu,
  DropdownItem,
  CellGroup,
  Uploader,
  Calendar,
  Tab,
  Tabs,
  Radio,
  RadioGroup,
  Checkbox,
  CheckboxGroup,
  DatetimePicker,
  List,
  Sidebar,
  SidebarItem,
  Empty,
  Circle,
  SwipeCell,
  Dialog,
  PasswordInput,
  NumberKeyboard,
  Loading
} from 'vant';

Vue.use(NavBar);
Vue.use(Tag);
Vue.use(Grid);
Vue.use(GridItem);
Vue.use(Collapse);
Vue.use(CollapseItem);
Vue.use(Image);
Vue.use(Col);
Vue.use(Row);
Vue.use(Search);
Vue.use(Icon);
Vue.use(Picker);
Vue.use(Popup);
Vue.use(Cell);
Vue.use(Form);
Vue.use(Field);
Vue.use(Button);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(CellGroup);
Vue.use(Uploader);
Vue.use(Calendar);
Vue.use(Tab);
Vue.use(Tabs);
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(Checkbox);
Vue.use(CheckboxGroup);
Vue.use(DatetimePicker);
Vue.use(List);
Vue.use(Sidebar);
Vue.use(SidebarItem);
Vue.use(Empty);
Vue.use(Circle);
Vue.use(SwipeCell);
Vue.use(Dialog);
Vue.use(PasswordInput);
Vue.use(NumberKeyboard);
Vue.use(Loading);
